import { AceCard } from '../AceCard';
import { ApplicationDataCardHeader } from './ApplicationDataCardHeader/ApplicationDataCardHeader';
import styles from './ApplicationDataCard.module.css';
import { ApplicationDataApplicantsTabs } from './ApplicationDataApplicantsTabs/ApplicationDataApplicantsTabs';
import { ApplicationDataLoanInformation } from './ApplicationDataLoanInformation';
import {
  ApplicationDataTabPage,
  ApplicationDataTabType,
  useApplicationDataStore,
} from '../../store/applicationDataStore';
import { RegisterCard } from '../RegisterCard/RegisterCard';

interface ApplicationDataCardProps {
  applicationID: string;
}

export const ApplicationDataCard: React.FC<ApplicationDataCardProps> = ({
  applicationID,
}) => {
  const { selectedTab } = useApplicationDataStore(applicationID);

  return (
    <AceCard
      id={`ApplicationData.${applicationID}`}
      data-test-id={`ApplicationData.${applicationID}`}
      noBorder={true}
      title="Application data"
      noContentPadding={true}
      isExpandedByDefault
    >
      <div className={styles.rootContainer}>
        {(selectedTab.type === ApplicationDataTabType.DRAFT ||
          selectedTab.type === ApplicationDataTabType.AXO_VERSION ||
          selectedTab.type === ApplicationDataTabType.ORIGINAL) &&
        selectedTab.currentPage === ApplicationDataTabPage.LENDERS ? (
          <RegisterCard applicationID={applicationID} />
        ) : (
          <>
            <ApplicationDataCardHeader applicationID={applicationID} />
            <ApplicationDataLoanInformation applicationID={applicationID} />
            <ApplicationDataApplicantsTabs applicationID={applicationID} />
          </>
        )}
      </div>
    </AceCard>
  );
};
